import Card from '@designSystem/Card';
import styled from 'styled-components';
import theme from '@theme';

export const StyledHeaderResults = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  margin: 1rem 4px;
  background-color: ${theme.palette.grey[100]};
  padding: 0.2rem;
  border-radius: 0.5rem;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const StyledCustomCard = styled(Card)`
  display: flex;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  box-shadow: none;
  & > div {
    border: 1px solid ${theme.palette.grey[100]};
    padding: 4px;
  }
`;

export const StyledTitleAvailableProductsStyle = styled.div`
  color: ${theme.palette.grey[500]};
  font-family: ${theme.fonts.primary};
  font-size: ${theme.fonts.size.sm};
  font-weight: ${theme.fonts.weight.medium};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledProductRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
  background: white;
  border-radius: 8px;
`;

export const StyledMainInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .product-badges {
    display: flex;
    align-items: center;
    gap: 8px;

    .separator {
      color: ${theme.palette.grey[400]};
      margin: 0 4px;
    }
  }
`;

export const StyledDetailsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding-top: 8px;
  & > div {
    display: flex;
    width: 50%;
    flex-direction: row;
    gap: 8px;
    flex-wrap: wrap;
  }
`;

export const PointMedian = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #d9d9d9;
  position: relative;
  top: 12px;
  margin-left: 4px;
  margin-right: 4px;
`;

export const StyledDetail = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 4px;
  border-radius: 4px;
  color: ${theme.palette.grey[500]};
  font-size: ${theme.fonts.size.sm};
  border: 1px solid transparent;

  svg {
    width: 16px;
    height: 16px;
    color: ${theme.palette.grey[500]};
  }

  .label {
    font-weight: ${theme.fonts.weight.medium};
  }

  .value {
    font-weight: ${theme.fonts.weight.regular};
  }
`;

export const StyledDetailLeft = styled(StyledDetail)`
  svg {
    width: 14px;
    height: 14px;
  }

  .value {
    background: ${theme.palette.grey[100]};
    padding: 2px 4px;
    border-radius: 4px;
  }

  select {
    border: ${theme.palette.grey[200]} 2px solid;
    background: transparent;
    padding: 2px 4px;
    border-radius: 4px;
  }
`;

export const StyledDetailRight = styled(StyledDetail)<{ color?: string }>`
  justify-content: flex-end;
  background: ${(props) =>
    props.color == 'blue' ? theme.palette.blue[100] : theme.palette.grey[100]};
  border: 1px solid
    ${(props) => (props.color == 'blue' ? theme.palette.blue[300] : theme.palette.grey[300])};
  color: ${(props) => (props.color == 'blue' ? theme.palette.blue[500] : theme.palette.grey[500])};

  svg {
    width: 14px;
    height: 14px;
    color: ${(props) =>
      props.color == 'blue' ? theme.palette.blue[500] : theme.palette.grey[400]};
  }

  .value {
    padding: 2px 4px;
    color: ${theme.palette.grey[900]};
    background: white;
    border-radius: 4px;
  }
`;

export const StyledPrice = styled.div`
  text-align: right;

  .monthly {
    font-size: ${theme.fonts.size.lg};
    font-weight: ${theme.fonts.weight.semibold};
    color: ${theme.palette.grey[900]};
  }

  .fees {
    font-size: ${theme.fonts.size.xs};
    color: ${theme.palette.grey[500]};
  }
`;

//

export const StyledOfferProductIcon = styled.div`
  margin-right: 12px;
`;

export const StyledOfferProductInfoIconContainer = styled.span`
  margin-top: 3px;
`;

export const StyledPriceGreyCard = styled.div`
  background-color: ${theme.palette.grey[50]};
  border-radius: 0.5rem;
  padding: 0.5rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  text-align: center;
`;

export const StyledProductDetails = styled.div`
  margin-top: 25px;
  font-weight: ${theme.fonts.weight.medium};
  font-size: ${theme.fonts.size.base};
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
`;

export const StyledProductLeadTime = styled.div`
  display: flex;
  align-items: center;
  column-gap: 6px;
  padding-left: 50px;
  line-height: ${theme.fonts.size.xs};
  font-size: ${theme.fonts.size.xs};
  font-weight: ${theme.fonts.weight.medium};
  color: ${theme.palette.grey[400]};
`;

export const StyledPopOverItemContainer = styled.div`
  display: flex;
  font-weight: ${theme.fonts.weight.medium};
  font-size: ${theme.fonts.size.sm};
  line-height: ${theme.fonts.spacing.sm};
  color: ${theme.palette.grey[500]};
  padding: 8px 16px;
  background-color: ${theme.palette.grey[50]};
  margin-top: 10px;
  border-radius: 4px;

  &:first-child {
    margin-top: 0px;
  }
`;
